export const formatUrl = (name: string) => {
  var tempTitle: string = name;
  tempTitle = tempTitle.toLowerCase();
  tempTitle = tempTitle.replace(/\s+/g, "-").toLowerCase();
  return tempTitle;
};

export const deformatUrl = (url: string) => {
  var tempUrl: string = url;
  tempUrl = tempUrl.toLowerCase();
  tempUrl = tempUrl.replace(/-/g, " ").toLowerCase();
  tempUrl = tempUrl.replace(/(^\w{1})|(\s+\w{1})/g, (letter: string) =>
    letter.toUpperCase()
  );
  return tempUrl;
};
